export default "__VITE_ASSET__CdnCoBTw__"